module.exports = __webpack_public_path__ + "img/reviews-image6.a834c65f.jpg";